import { useEffect, useState } from 'react';

export default function useCountdown(initialSeconds = 0) {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(
    function tickCountdown() {
      if (seconds <= 0) return undefined;

      const timeoutId = window.setTimeout(() => {
        setSeconds((currentSeconds) => Math.max(currentSeconds - 1, 0));
      }, 1000);

      return () => window.clearTimeout(timeoutId);
    },
    [seconds],
  );

  return [seconds, setSeconds];
}
